<template>
    <form class="availability-percent-filter" :class="classes">
        <h4 v-if="!complex">{{ $t('availabilities.filter.availability') }}</h4>
        <div class="filter-toggle-button-holder is-clearfix" v-else>
            <button class="button is-pulled-right" @click.prevent="toggle()"><i class="icon filter-icon fa fa-filter"></i> Filter <i class="icon arrow-icon fa fa-angle-up" v-if="!isCollapsed"></i><i class="icon arrow-icon fa fa-angle-down" v-else></i></button>
        </div>
        <div class="field is-horizontal" :class="{'is-collapsed': isCollapsed}">
            <div class="field-body">
                <div class="field">
                    <div class="control is-clearfix">
                        <label class="checkbox is-pulled-right has-tag">
                            <input type="checkbox" :checked="value[3]" @change="checkbockChanged(3, $event)" />
                            <span class="tag is-small is-danger"><span>{{ $t('availabilities.nonAvailable') }}</span></span>
                        </label>

                        <label class="checkbox is-pulled-right">
                            <input type="checkbox" :checked="value[2]" @change="checkbockChanged(2, $event)" />
                            20-1%
                            <battery v-model="battery1" :isSmall="true"></battery>
                        </label>

                        <label class="checkbox is-pulled-right">
                            <input type="checkbox" :checked="value[1]" @change="checkbockChanged(1, $event)" />
                            50-21%
                            <battery v-model="battery2" :isSmall="true"></battery>
                        </label>

                        <label class="checkbox is-pulled-right">
                            <input type="checkbox" :checked="value[0]" @change="checkbockChanged(0, $event)" />
                            100-51%
                            <battery v-model="battery3" :isSmall="true"></battery>
                        </label>

                        <label class="checkbox is-pulled-right" v-if="complex">
                            <input type="checkbox" :checked="value[4]" @change="checkbockChanged(4, $event)" />
                            <span class="tag is-small status-tag tainted">{{ $t('availabilities.filter.onlyTainted') }}</span>
                            <info-i :track="['AvailabilitiesByCampsite', 'changedAvailabilities']">{{ $t('availabilities.flyouts.changedAvailabilities') }}</info-i>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import { Tracking } from '../../../utils';
    import Battery from './battery';
    import InfoI from './info-i';

    export default {
        name: 'availability-percent-filter',

        components: {
            Battery,
            InfoI,
        },

        props: {
            value: {
                type: Array,
                'default': () => ([true, true, true, true, true]),
            },
            classes: {
                type: String,
                'default': () => (''),
            },
            complex: {
                type: Boolean,
                'default': () => (false),
            },
            trackName: {
                type: String,
                'default': () => (null),
            },
        },

        data() {
            return {
                isCollapsed: true,
                battery1: 20,
                battery2: 50,
                battery3: 100,
            };
        },

        methods: {
            checkbockChanged(idx, event) {
                let val = [
                    !!this.value[0],
                    !!this.value[1],
                    !!this.value[2],
                    !!this.value[3],
                ];

                val[idx] = event.currentTarget.checked;
                this.$emit('input', val);

                const trackMapping = [
                    '100-51%',
                    '50-21%',
                    '20-1%',
                    'Ausgebucht',
                    'Nur angepasste Kontingente',
                ];
                this.track('filterClicked', trackMapping[idx], val[idx]);
            },

            toggle() {
                this.isCollapsed = !this.isCollapsed;
                this.$emit('toggle', !this.isCollapsed);
                this.track('filterToggled', this.isCollapsed ? 'off' : 'on');
            },

            track(action, label = null, val = null) {
                if(!this.track) {
                    return;
                }
                Tracking.trackEvent(this.trackName, action, label, val);
            }
        },
    };
</script>

<style lang="scss">
    @import './availability-percent-filter.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/availabilities/availability-percent-filter.vue